
export const MAJOR_LIST = ["SE", "IA", "IoT", "AI"];
export const GENDER_LIST = ["Nam", "Nữ"];

export const CLUB_LIST = [
    "FVC - FPT Vovinam Club",
    "FFC - Câu Lạc Bộ Bóng Đá FPTU HCM",
    "FFC - FPT Chess Club",
    "FBC - FPTU HCM Basketball Club",
    "FVB - Câu Lạc Bộ Bóng Chuyền FPTU HCM",
    "FTI - FPT Traditional Instruments",
    "FBK - FPT Beat King Club",
    "F# - Live Music Club",
    "FStyle - FStyle Crew",
    "SiTigroup - Cộng đồng Sinh viên Tình nguyện SiTigroup",
    "JSC - CLB Phong Cách Nhật Bản",
    "EFC - English Funny Club",
    "FIA - FPT Information Assurance Club",
    "HNF - Hardware Network FPTU",
    "FEV - FPT Event Club",
    "CSG - Câu Lạc Bộ Truyền Thông Cóc Sài Gòn",
    "MEC - Multimedia Entertainment Club"
];